import Typography from "@material-ui/core/Typography";
import {Grid} from "@material-ui/core";
import {format} from "date-fns";
import React from "react";

export default function PropertyRequirementViewTile({consumerData}) {
    return (
        <>
            <Typography variant="h5" component="h2">
                Property Requirement
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                    When do you need coverage on your property?<br/>
                    <b>{(consumerData?.coverageStartDate) ? format(new Date(consumerData?.coverageStartDate), 'MM/dd/yyyy') : ''}</b>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    What is the value of the property excluding land?<br/>
                    <b>{consumerData?.coverageAmount}</b>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    Why do you need insurance?<br/>
                    <b>{consumerData?.insuranceReason}</b>
                </Grid>
                {consumerData?.insuranceReason === 'Shopping Insurance' &&
                <Grid item xs={12} sm={6} md={4}>
                    What insurance company currently insures your property?<br/>
                    <b>{consumerData?.currentInsurer}</b>
                </Grid>
                }
                <Grid item xs={12} sm={6} md={4}>
                    How is the property used?<br/>
                    <b>{consumerData?.propertyUsageLabel}</b>
                </Grid>
            </Grid>
        </>
    );
}
